
import { Method } from 'axios';
import { store } from "../store/index";
import { logout } from '../store/auth/actions';
import { SPINNER_TOGGLE_OFF } from '../store/spinner/types';
import { GlobalAccessToken } from '@aglive/frontend-core';
import { callAPI, getAPI } from './network';


export const refresh = () => {
    return new Promise(async (resolve, reject) => {
      const url = getAPI().POST.refreshToken;
      const data = {};
      const PostMethod: Method = 'POST';
      
      callAPI({ url, method: PostMethod, data })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
            console.error('refresh token -> error', error);
            if(store.getState().auth.isLoggedIn) {
              logout(action => store.dispatch(action), true);
            }
            store.dispatch({type: SPINNER_TOGGLE_OFF});
            reject(error);
          },
        );
    });
  }
  
const revokeToken = () => {
    return new Promise(async (resolve, reject) => {
        const url = getAPI().POST.revokeToken;
        const data = {};
        const PostMethod: Method = 'POST';
        callAPI({ url, method: PostMethod, data })
        .then((response) => {
            resolve(response);
        })
        .catch((error) => {
            reject(error);
            },
        );
    });
}
  
export const authLogout = () => {
    return GlobalAccessToken.authLogout(revokeToken);
}
  